import { Component, Input } from '@angular/core';
import { AlertController, IonicPage, ModalController, NavController, NavParams, ViewController } from 'ionic-angular';
import { APIServiceProvider } from '../../common/services/api.service';

/**
 * Generated class for the ModalsBankReceiptPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'bank-detail-history-model',
  templateUrl: 'bank-detail-history.html',
})
export class BankDetaisHistory {

  @Input() data : any = {};




 constructor(
  public modalCtrl: ModalController,
  private apiService: APIServiceProvider,
  public viewCtrl:ViewController,
   private alertController: AlertController,
  public navParam: NavParams
) { }

  ngOnInit() { 
     this.data = this.navParam.data.data;
      console.log(this.data)
}
dismiss() {
  this.viewCtrl.dismiss();
}



} 



// WEBPACK FOOTER //
// ./src/modals/bank-detail-history/bank-detail-history.ts